var InteractionType;
(function (InteractionType) {
    InteractionType["Click"] = "click";
    InteractionType["Focus"] = "focus";
    InteractionType["Blur"] = "blur";
    InteractionType["Change"] = "change";
})(InteractionType || (InteractionType = {}));
export default InteractionType;
